<div fxLayout="row" style="max-height: 50px;" #Header>
  <div fxFlex="none" class="textcontainer" style="text-align: center;">
    <!-- <button (click)="playSound()"> play sound </button> -->
    <button *ngIf="!IsWaiting && !PlayStop" mat-icon-button (click)="playStopSound(30)" [matTooltip]="'30 Sec Playback'">
      <mat-icon>replay_30</mat-icon>
    </button>
    <button *ngIf="!IsWaiting && !PlayStop" mat-icon-button (click)="playStopSound(10)" [matTooltip]="'10 Sec Playback'">
      <mat-icon>replay_10</mat-icon>
    </button>
    <button mat-icon-button (click)="playStopSound()" [matTooltip]="PlayStop ? 'Stop' : 'Live Playback'">
      <mat-icon>{{PlayStop ? 'stop' : 'play_arrow'}}</mat-icon>
    </button>
    <!-- for testing only -->
    <!-- <button mat-icon-button (click)="toggleBsonLoop()" [matTooltip]="PlayStop ? 'Stop' : 'test Playback'">
      <mat-icon>{{sensorBsonLoopRunning ? 'stop' : 'play_arrow'}}</mat-icon>
    </button> -->
  </div>
  <div fxFlex class="textcontainer" *ngIf="!IsWaiting">
    {{Title}}
  </div>
  <app-spinninganimation fxFlex *ngIf="IsWaiting" class="textcontainer"></app-spinninganimation>
  <div style="text-align: center;">
    <button mat-icon-button [matTooltip]="'Equalizer'" class="textcontainer" (click)="onEQClick()">
      <app-equalizeranimation></app-equalizeranimation>
    </button>
  </div>
</div>